import { Example } from "../models/ExampleModel";
import { ExplanationModel } from "../models/ExplanationModel";

export const vozActivaPasivaExplanation: ExplanationModel = {
    title: "📖 What is Voz Activa vs. Voz Passiva?",
    description: "In active voice, the subject of the sentence performs the action. In passive voice, the subject of the sentence receives the action. The key difference between active and passive sentences is the focus — whether the focus is on the subject performing the action or the object receiving the action.",
    examples: [
        "Active Voice: The teacher explains the lesson.",
        "Passive Voice: The lesson is explained by the teacher.",
        "Active Voice: They built the house in one year.",
        "Passive Voice: The house was built in one year."
    ],
    bulletPoints: [
        "In active voice, the subject performs the action.",
        "In passive voice, the object becomes the subject of the sentence.",
        "Passive voice uses the verb 'to be' followed by the past participle.",
        "In passive voice, the agent (doer of the action) is optional and often omitted."
    ]
};

export const activeAndPassiveVoiceExamples: Example[] = [
    {
        sentence: "El chef prepara la comida.",
        explanation: "In this active sentence, 'El chef' (subject) performs the action 'prepara' (prepares) on the object 'la comida' (the food)."
    },
    {
        sentence: "La comida es preparada por el chef.",
        explanation: "In this passive sentence, 'La comida' (subject) receives the action 'es preparada' (is prepared) by the agent 'el chef' (the chef)."
    },
    {
        sentence: "Nosotros escribimos las cartas.",
        explanation: "In this active sentence, 'Nosotros' (subject) perform the action 'escribimos' (write) on the object 'las cartas' (the letters)."
    },
    {
        sentence: "Las cartas son escritas por nosotros.",
        explanation: "In this passive sentence, 'Las cartas' (subject) receive the action 'son escritas' (are written) by the agent 'nosotros' (us)."
    },
    {
        sentence: "El estudiante lee el libro.",
        explanation: "In this active sentence, 'El estudiante' (subject) performs the action 'lee' (reads) on the object 'el libro' (the book)."
    },
    {
        sentence: "El libro es leído por el estudiante.",
        explanation: "In this passive sentence, 'El libro' (subject) receives the action 'es leído' (is read) by the agent 'el estudiante' (the student)."
    },
    {
        sentence: "La policía arresta al criminal.",
        explanation: "In this active sentence, 'La policía' (subject) performs the action 'arresta' (arrests) on the object 'al criminal' (the criminal)."
    },
    {
        sentence: "El criminal es arrestado por la policía.",
        explanation: "In this passive sentence, 'El criminal' (subject) receives the action 'es arrestado' (is arrested) by the agent 'la policía' (the police)."
    }
];